import React from 'react'
import styled, { withTheme } from 'styled-components'
import { media, Container } from '../../utils/style'
import { Heading } from 'rebass'
import { Box } from 'rebass'
import { string } from 'prop-types'

const Logo = styled(Box)`
  padding: 55px;
  ${media.LargeScreenUp`
  padding: 65px;
  `}
  position: relative;
  svg {
    transform: translate(-50%, -50%) scale(1.8);
    ${media.LargeScreenUp`
    transform: translate(-50%, -50%) scale(2.2);
    `}
    position: absolute;
    left: 50%;
    top: 50%;
  }
`
Logo.displayName = 'Logo'

class ContentSectionHeading extends React.PureComponent {
  render() {
    return (
      <Container maxWidth={this.props.theme.content.max.width}>
        {this.props.brand !== '' && <Logo>{this.props.brand}</Logo>}
        <Heading
          textAlign="center"
          fontSize={[6, 7]}
          px={60}
          color={this.props.fg || this.props.theme.colors.blue}
        >
          {this.props.title}
        </Heading>
      </Container>
    )
  }
}

ContentSectionHeading.propTypes = {
  title: string,
  fg: string
}

const Themed = withTheme(ContentSectionHeading)
Themed.displayName = 'SectionHeading'

export default Themed
